import { useState, useEffect } from "react";
import { InfoBanner } from "../../components/data/InfoBanner";
import { usePlayerLists } from "./hooks/use-player-lists";
import { usePlayerSearch } from "./hooks/use-player-search";
import { DeleteModal, ListsSidebar, ListDetail } from "./components";

export const PlayerListsPage = () => {
  const {
    lists,
    selectedListId,
    setSelectedListId,
    selectedList,
    players,
    filter,
    setFilter,
    tableData,
    loadingLists,
    loadingPlayers,
    saving,
    createList,
    deleteList,
    addPlayer,
    removePlayer,
  } = usePlayerLists();

  const search = usePlayerSearch(players);

  const [pendingDeleteList, setPendingDeleteList] = useState(null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape" && pendingDeleteList) setPendingDeleteList(null);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [pendingDeleteList]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 relative overflow-hidden">
      <div className="container max-w-6xl mx-auto px-8 sm:px-12 lg:px-16 py-16">
        <div className="relative z-10 mb-6">
          <InfoBanner
            title="Player Lists"
            description="Create and manage custom player lists. Add players via search or CSV import, then use these lists across the platform."
          />
        </div>

        <div className="relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
            <aside className="lg:col-span-4">
              <ListsSidebar
                lists={lists}
                selectedListId={selectedListId}
                onSelectList={setSelectedListId}
                onCreateList={createList}
                onDeleteList={setPendingDeleteList}
                loadingLists={loadingLists}
                saving={saving}
              />
            </aside>

            <main className="lg:col-span-8">
              <ListDetail
                selectedList={selectedList}
                tableData={tableData}
                filter={filter}
                onFilterChange={setFilter}
                loadingPlayers={loadingPlayers}
                onRemovePlayer={removePlayer}
                search={search}
                onAddPlayer={addPlayer}
              />
            </main>
          </div>
        </div>

        <DeleteModal
          open={!!pendingDeleteList}
          onClose={() => setPendingDeleteList(null)}
          onConfirm={() => { deleteList(pendingDeleteList); setPendingDeleteList(null); }}
          listName={pendingDeleteList?.name}
          loading={saving}
        />
      </div>
    </div>
  );
};
